import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '../../utils';
import IconCheckboxContained from '../../icons/ui/IconCheckboxContained';
import IconCheckboxOutlined from '../../icons/ui/IconCheckboxOutlined';
import IconCheckboxUnchecked from '../../icons/ui/IconUnchecked';
import styles from './Checkbox.module.css';
function getCheckboxIcon(size, variant, checked, className) {
    if (checked === false) {
        return _jsx(IconCheckboxUnchecked, { size: size, className: className }, void 0);
    }
    if (variant === 'outlined') {
        return _jsx(IconCheckboxOutlined, { size: size }, void 0);
    }
    if (variant === 'indeterminate') {
        return _jsx(IconCheckboxOutlined, { size: size }, void 0);
    }
    // default
    return _jsx(IconCheckboxContained, { size: size, className: className }, void 0);
}
const getStyleBySize = (size = '') => {
    switch (size.toUpperCase()) {
        case 'SMALL':
            return styles.small;
        case 'MEDIUM':
        default:
            return styles.medium;
    }
};
const Checkbox = ({ id, name, children, className, label, secondaryLabel, checked = false, onChange, size = 16, fullWidthLabel = false, fullWidth = false, variant = 'contained', disabled = false, labelSize, readonly, }) => (_jsxs("label", Object.assign({ htmlFor: id, className: classNames(styles.labelWrapper, className, fullWidth ? styles.fullWidth : undefined, disabled ? styles.disabled : undefined, readonly ? styles.readonly : undefined) }, { children: [_jsx("input", { id: id, className: styles.input, type: "checkbox", name: name, onChange: onChange, disabled: disabled, checked: checked }, void 0), getCheckboxIcon(size, variant, checked, styles.icon), _jsxs("div", Object.assign({ className: styles.labelColumn }, { children: [secondaryLabel && (_jsx("div", Object.assign({ className: classNames(styles.secondaryLabel, getStyleBySize(labelSize), fullWidthLabel ? styles.fullWidthLabel : '') }, { children: secondaryLabel }), void 0)), label && (_jsx("span", Object.assign({ className: classNames(styles.label, getStyleBySize(labelSize), checked ? styles.checkedLabel : '', fullWidthLabel ? styles.fullWidthLabel : '') }, { children: label }), void 0))] }), void 0), children] }), void 0));
export default Checkbox;
